import { trialConfig } from "../utils/trialConfig";

export default function TrialBankAccounts() {
  return (
    <div className="p-6 border border-blue-200 bg-blue-50 dark:bg-blue-900/20 dark:border-blue-800 rounded-xl">
      <h4 className="mb-3 text-lg font-semibold text-blue-800 dark:text-blue-300">
        🏦 Rekening Pembayaran (Jika Lanjut)
      </h4>

      {trialConfig.bankAccounts.map((bank, i) => (
        <div key={i} className="mb-3 text-sm text-gray-700 dark:text-gray-300">
          <p>
            <b>{bank.bank}</b> — {bank.number}
          </p>
          <p>a.n {bank.name}</p>
        </div>
      ))}

      <p className="text-xs text-gray-500">
        Pembayaran hanya dilakukan jika Anda memilih melanjutkan setelah trial.
      </p>
    </div>
  );
}
